import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function SubscriptionProvider({ children }) {
  useInjectSaga({ key: 'subscriptionProvider', saga });
  useInjectReducer({ key: 'subscriptionProvider', reducer });

  return React.Children.only(children);
}

SubscriptionProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withSubscription } from './withSubscription';
export default compose(withConnect, memo)(SubscriptionProvider);
